const TRAINER_STEVEN_ASMUSSEN = "3fdcf9a9-f166-05a9-83dc-5e2ab43ef74f";
const TRAINER_BOB_BAFFERT = "e78dcae2-490e-fada-aede-19466cff1ab5";
const TRAINER_JOHN_SADLER = "8515f808-543b-bc5c-56af-ebff732c6361";
const TRAINER_DOUG_ONEILL = "2f3ba5a7-7660-7eae-b379-a1f66e5f4e4e";
const TRAINER_NO_HORSE = "18bd61e3-6c38-4a51-8017-3d8e61183768";

export const Trainers = [
  TRAINER_STEVEN_ASMUSSEN,
  TRAINER_BOB_BAFFERT,
  TRAINER_JOHN_SADLER,
  TRAINER_DOUG_ONEILL,
  TRAINER_NO_HORSE
];
